import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

/**
 * Uploads a file to Firebase Storage and returns its public URL
 * @param {File} file
 * @param {string} path
 * @returns {Promise<string>}
 */
export const uploadImage = async (file, path) => {
  if (!file) return "";

  const storage = getStorage();
  const storageRef = ref(storage, path);

  await uploadBytes(storageRef, file);
  const downloadURL = await getDownloadURL(storageRef);

  return downloadURL;
};
